// extracted by mini-css-extract-plugin
export default {"btn":"OverDueBooksRow_btn__ESwtc","table-number-cell":"OverDueBooksRow_table-number-cell__G7X4E","tr":"OverDueBooksRow_tr__W3S-B"};